import React, { useState,useContext,useEffect } from 'react';
import { BuilderContext, useDrawer,useAction, } from 'react-custom-flow-builder';
import { Form, Button, Input,Drawer } from 'antd';
import "antd/dist/antd.css";
import { useDispatch, useSelector } from 'react-redux';
import { setAddedNodeList } from '../../app/slice/flowBuilderSlice';
import { Divider } from 'antd';
import "./ActionPanel.css"

const ActionPanel = (props:any) => {
  const dispatch = useDispatch();
  const AddedNodesObj=useSelector((state:any)=>state.flowBuilder.addedNodeList);
  const { selectedNode: node ,registerNodes,setShowActionPanel} = useContext(BuilderContext);
  const { addNode,addNewNode } = useAction();

  const [selectedRegisterNode, SetSelectedRegisterNode] = useState<any>([]);


  const handleAddNode =(nodeType:any,name:any,className:string,configElements:any,iconUrl?:any,iconBgColor?:any,item?:any) => {
    // addNode(nodeType);
    const nodeDetails= {
      nodeId:item.Id,
      parentId:item.parentId
    }
    addNewNode(nodeType,undefined,name,className,configElements,iconUrl,iconBgColor,nodeDetails)
    let NodesArr:any =JSON.parse(JSON.stringify(AddedNodesObj));
    NodesArr.push(name);
    dispatch(setAddedNodeList(NodesArr));
    setShowActionPanel(false);
    console.log("props-->",props);
    return props.cancel();
  };

  const findNode = (nodes:any, nodeName:any)=> {
    return nodes.some((e:any) =>{
      if(e.name.toLocaleLowerCase() == nodeName) {
        console.log("findNode::",e);
        if('addableNodes' in  e){
            SetSelectedRegisterNode(e.addableNodes);
        }
        return e;
      }
      else if(e.addableNodes) return findNode(e.addableNodes, nodeName)
    })
  }

  const getNodes=()=>{
    const nodeName=node?.name.toLocaleLowerCase();
    return findNode(registerNodes,nodeName);
    }
  const addedNode=(nodeName:any)=>{
      return AddedNodesObj.includes(nodeName);
    }

  useEffect(() => {
    getNodes();
  }, []);


  return (
    <div className='popover-section'>
      <div className='action-panel-title'>Choose an action</div>
      <Divider className='action-panel-divider'></Divider>
      <div className='popover-body'>
       
        <div className='Selected-Item'>Selected Item : {node?.name}</div>
        <div className='addable-item-list'>
      {selectedRegisterNode.map((item:any) => {
          // console.log("registerNodes",item,selectedRegisterNode)

              return (
                <>
                {
                <div 
                  className="flow-builder-addable-node-item"
                  // style={{backgroundColor: addedNode(item.name)?"#8AFF8A":""}}
                  key={item.type}
                  onClick={() => {
                    // if(!addedNode(item.name))
                    handleAddNode(item.type,item.name,item.className,item.configElements,item.iconUrl,item.iconBgColor,item)}}
                >
                  <span className="flow-builder-addable-node-icon">
                    {/* {registerNode?.addIcon />} */}
                    <div className={`addable-node-icon ${item.className?item.className:''}`}  style={{backgroundColor: item.iconBgColor?item.iconBgColor:"" }}>
                       <img className='addable-icon-img' src={item.iconUrl?item.iconUrl:""} alt="" />
                </div>
                  </span>
      
                  <span>{item.name}</span>
                </div>
                }
              </>

              );
          //   })
        
          // }

        })}
      </div>
      </div>
    </div>

  );
};

export default ActionPanel;